module.exports = __webpack_public_path__ + "img/Agresivitas-Label0.a6703c59.png";